// src/services/researchApi.js
import apiService from './apiService';

const researchApi = {
  list: (params = {}) => apiService.get('/research', { params }),
  create: (data) => apiService.post('/research', data),
  update: (id, data) => apiService.put(`/research/${id}`, data),
  remove: (id) => apiService.delete(`/research/${id}`),
};

export default researchApi;
